"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AddressAppWrapper = require("./AddressAppWrapper");
var _forms = require("./forms");
var _jsxRuntime = require("react/jsx-runtime");
const AddressForm = props => {
  const {
    appConfiguration,
    customerId
  } = props;
  if (appConfiguration.customerId == null || typeof appConfiguration.customerId === 'undefined') {
    appConfiguration.customerId = customerId;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AddressAppWrapper.AddressAppWrapper, {
    configuration: appConfiguration,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_forms.AddressFormInternal, {
      ...props
    })
  });
};
var _default = exports.default = AddressForm;
//# sourceMappingURL=AddressForm.js.map